// src/constants/BlogsContent.js
export const logos = [
  {
    photo: `${process.env.REACT_APP_CLIENT_URL}/images/logos/aa.jpeg`,
  },
  {
    photo: `${process.env.REACT_APP_CLIENT_URL}/images/logos/bb.jpeg`,
  },
  {
    photo: `${process.env.REACT_APP_CLIENT_URL}/images/logos/cc.jpeg`,
  },
  {
    photo: `${process.env.REACT_APP_CLIENT_URL}/images/logos/dd.jpeg`,
  },
  {
    photo: `${process.env.REACT_APP_CLIENT_URL}/images/logos/ee.jpeg`,
  },
  {
    photo: `${process.env.REACT_APP_CLIENT_URL}/images/logos/ff.jpeg`,
  },
  {
    photo: `${process.env.REACT_APP_CLIENT_URL}/images/logos/gg.jpeg`,
  },
  {
    photo: `${process.env.REACT_APP_CLIENT_URL}/images/logos/hh.jpeg`,
  },
  {
    photo: `${process.env.REACT_APP_CLIENT_URL}/images/logos/kk.jpg`,
  },
];
